import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'

import { ThemeButton, useModalContext } from '../../../../ui'
import { dataToXLS, getFormattedTime } from '../../../../core/utils'
import { ExportSomethingDialog } from './export-something.dialog'
import { CAMPAIGNS_TABLE_COLUMNS } from '../../../campaigns/components/table'
import { useCampaignsContext } from '../../../campaigns'
import { useCampaignsCalls } from '../../hooks'

export const ExportToXLSBtn = () => {
  const intl = useIntl()
  const combos = useSelector((state) => state.combos)
  const {
    actions: { open },
  } = useModalContext()
  const { tableSelection, search } = useCampaignsContext()
  const { getCampaignsCall } = useCampaignsCalls()
  const from = 'campaigns'

  const [loading, setLoading] = useState(false)

  const mainExport = async (data) => {
    const fileName = `campañas_${getFormattedTime()}.xlsx`
    await dataToXLS(data, CAMPAIGNS_TABLE_COLUMNS, combos, intl, from, fileName)
  }

  const handleExportAll = async () => {
    setLoading(true)
    try {
      const { data } = await getCampaignsCall({
        params: { ...search, _num_x_pagina: 10000, _pagina: 1 },
      })
      await mainExport(data['campanas'])
    } catch (error) {
      console.error('Error al exportar todas las campañas:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleExport = async () => {
    if (!tableSelection?.length) {
      open({ Component: ExportSomethingDialog })
      return
    }

    setLoading(true)
    try {
      await mainExport(tableSelection)
    } catch (error) {
      console.error('Error al exportar la selección:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <ThemeButton
        color="primary"
        onClick={handleExport}
        style={{ marginRight: '1em' }}
        loading={loading}
        disabled={loading}
      >
        {intl.formatMessage(
          { id: 'pages.sir.exportToXLS.exportSelectionBtn.title' },
          { count: tableSelection.length }
        )}
      </ThemeButton>
      <ThemeButton
        color="primary"
        loading={loading}
        disabled={loading}
        style={{ marginRight: '1em' }}
        onClick={handleExportAll}
      >
        {intl.formatMessage({ id: 'pages.sir.exportToXLS.exportAllBtn.title' })}
      </ThemeButton>
    </>
  )
}
